module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"placeholder":"Buscar por nome do link...","shortcut.text":"Nome do link"},"en-US":{"placeholder":"Find by link name...","shortcut.text":"Name of the link"}}')
  delete Component.options._Ctor
}
